<script lang="ts">
    const publicTitle = "Ryosuke Support Project"

    const mainHeaderImagePath = {
        normal:    "image/sp/ryosuke-support-project-main.png",          
    }

    //-- SNS Icon Link ------------------------------------------------------
    const snsLink = {
        youtube : "https://www.youtube.com/channel/UC_9emudpDNXJ6knTnxyRIJg",
        insta   : "https://www.instagram.com/ryosuke_support_project/",
        twitter : "https://twitter.com/r_tanaka_sp"
    };
    
    //-- SNS Icon Path ------------------------------------------------------
    const snsIconPath = {
        youtube : "image/common/youtube-icon.png",
        insta   : "image/common/instagram-icon.png",
        twitter : "image/common/twitter-icon.png"
    }

    //-- Scroll to Support Activity -----------------------------------------
    function scrollIntoView({ target }){
        const el = document.querySelector(target.getAttribute('href'));
        if(!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }
</script>

<section id="site-main-first-view" class="first-view">
    <div class="first-view-container">
        <img class="first-view-image" alt="{publicTitle}" src="{mainHeaderImagePath.normal}">
        <div class="container">
            <div class="first-view-container_title">
                <span class="first-view-container__title-item">Ryosuke</span>
                <span class="first-view-container__title-item">Support</span>
                <span class="first-view-container__title-item">Project</span>
            </div>
            <ul>
                <li><a href="{snsLink.youtube}"><img src="{snsIconPath.youtube}" alt="{publicTitle}_Youtube_Channel"></a></li>
                <li><a href="{snsLink.insta}"><img src="{snsIconPath.insta}" alt="{publicTitle}_Instagram"></a></li>
                <li><a href="{snsLink.twitter}"><img src="{snsIconPath.twitter}" alt="{publicTitle}_Twitter"></a></li>
            </ul>
            <div class="first-view-container__support-activity-button-area">
                <button class="first-view-container__support-activity-button" href="#support-activity-section" on:click|preventDefault={scrollIntoView}>
                    Support Project Here
                </button>
            </div>
        </div>
    </div>
</section>

<style>
    .first-view-image {
        display:    inline-block;
        width:      100vw;
        height:     700px;
        object-fit: cover;
    }

    .first-view-container {
        top:        0;
        width:      100vw;
        height:     700px;
        object-fit: cover;
    }

    .first-view-container .container {
        position:    absolute;
        top:         0;
        left:        5%;
        width:       95%;
        margin:      0 auto;
        padding-top: 200px;
        text-align:  center;
    }

    .first-view-container_title {
        display:       inline-block;
        margin-bottom: 120px;
        font-size:     40px;
        font-weight:   bold;
        font-family:   'STKaiti';
        color:         white;
        text-align:    left;
        text-shadow:   1px 1px 15px #27dcc4;
    }

    .first-view-container__title-item {
        display:       block;
        margin-bottom: 8px;
    }

    .first-view-container__title-item:nth-child(2) {
        padding-left: 60px;
    }

    .first-view-container__title-item:nth-child(3) {
        padding-left: 110px;
    }

    .first-view-container__support-activity-button-area {
        text-align: center;
    }
    .first-view-container__support-activity-button {
        width:            224px;
        height:           48px;
        font-size:        18px;
        font-weight:      bold;
        color:            white;
        border:           none;
        border-radius:    8px;
        background-color: #4fb4c3;
    }

    .container li {
        display:    inline-block;
        list-style: none;
        width:      64px;
        height:     64px;
        margin:     8px;
    }

    .container ul {
        margin:  0 0 24px;
        padding: 0;
    }

    .container li img {
        position:      absolute;
        width:         64px;
        border-radius: 16px;
        transform:     translateX(-32px);
        transition:    0.2s;
    }
</style>